import React from "react";
import { Warning } from "@culturehq/components";

import { Trans } from "app/utils";

const NoWidgets = () => (
  <Warning>
    <strong><Trans>Uh oh!</Trans></strong> <Trans>No widgets configured.</Trans>
  </Warning>
);

export default NoWidgets;
